<template lang="pug">
  #reset-password
    .columns.is-flex.is-justify-content-center.is-align-items-center
      .column.is-5
        .box.animated.fadeIn
          WtTitle(card-title) Reset Your Password
          form(@submit.prevent="resetPassword")
            BField(
              label="New Password"
              :type="{ 'is-danger': errors.has('password') }"
              :message="errors.first('password')"
            )
              BInput(
                password-reveal
                name="password"
                type='password',
                v-model='password',
                placeholder='New password'
                v-validate="'required|min:8'"
                ref="password"
              )
            PasswordComplexityCheck(:password="password")
            br
            BField(
              label="Confirm New Password"
              :type="{ 'is-danger': errors.has('confirm') }"
              :message="errors.first('confirm')"
            )
              BInput(
                password-reveal
                name="confirm"
                type='password',
                v-model='passwordConfirm',
                placeholder='Confirm new password'
                v-validate="'required|confirmed:password'"
                data-vv-as="confirm password"
              )
            br
            WtButton(type="submit" :loading="loading") Submit
</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@/components/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import PasswordComplexityCheck from "@@/PasswordComplexityCheck.vue";

export default {
  name: "ResetPassword",

  components: { WtTitle, WtButton, PasswordComplexityCheck },

  data() {
    return {
      password: "",
      passwordConfirm: "",
      loading: false
    };
  },

  computed: {
    urlToken() {
      return this.$route.query.token;
    }
  },

  methods: {
    ...mapActions("registration", ["resetForgotPassword"]),
    ...mapActions("authMember", ["setPasswordChanged"]),
    ...mapActions(["resetState"]),

    resetPassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            password: this.password,
            token: this.urlToken,
            password_confirmation: this.passwordConfirm
          };
          this.loading = true;
          this.resetForgotPassword(payload).then(response => {
            if (response) {
              this.setPasswordChanged(true);
              const data = response.data.data;
              const params = {
                username: data.username,
                password: this.password,
                programId: data.programId,
                isPartner: 0
              };
              // log them in
              this.$auth.login({ data: params });
            } else {
              this.$auth.logout();
              this.resetState();
              window.location.reload();
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="sass">
#reset-password
  background-color: $white-ter
  height: 100vh
  .columns
    height: 100vh
</style>
